// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"78":"d1a24c82","453":"d3c6ef51","885":"5bf00471"}[chunkId] + ".chunk.js";
};